import router from "@/router";

export const unauthorizedInterceptor = async (error) => {
  localStorage.removeItem("access_token");

  await router.push({ name: "Login" });

  return Promise.reject(error);
};
